<template>
	<div class="member">
		<div class="topBar box" v-if="topBar">
			<i class="iconfont icon-arrow-right" @click="goBack"></i>
			<div class="title flex-1">{{title}}</div>
			<div class="subNav" :class="{active:subNav}">
				<div class="nav-hd" @click="subNav = true">
					<span class="line-1"></span>
					<span class="line-2"></span>
					<span class="line-3"></span>
				</div>
				<div class="nav-bd">
					<div class="mask" @click="subNav = false"></div>
					<div class="navs-group">
						<ul class="nav-list">
			            	<router-link :to='{name:"homeView"}' tag='li' class="nav-item">首页</router-link>
			        		<router-link :to='{name:"newsView"}' tag='li' class="nav-item ">新闻</router-link>
			        		<router-link :to='{name:"bigView"}' tag='li' class="nav-item">大咖说</router-link>
			        		<router-link :to='{name:"videoView"}' tag='li' class="nav-item">视频</router-link>
			        		<router-link :to='{name:"featuredView"}' tag='li' class="nav-item">深度</router-link>
			        		<router-link :to='{name:"policyView"}' tag='li' class="nav-item">政策</router-link>
			        		<div class="close-btn" @click="subNav = false"><i class="iconfont">&#xe61f;</i></div>
			            </ul>
					</div>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>
<script>
import $ from 'jquery'
export default {
	mounted () {
		let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		$(".member").css("min-height",clientHeight)
	},
	data () {
		return {
			title : '',
			subNav: false,
			topBar: true
		}
	},
	methods : {
		goBack () {
			this.$router.go(-1);
		}
	},
	watch: {
    	'$route' (to, from) {
    		this.title = to.meta.title;
    		if(to.name == 'registerView' || to.name == 'loginView'){
    			this.topBar = false;
    		}else {
    			this.topBar = true;
    		}
    		document.title = to.meta.title;
    	}
	},
	beforeRouteEnter (to, from, next) {
    	next(vm => {
			$("body").addClass('noFoot');
			vm.title = to.meta.title;
			if(to.name == 'registerView' || to.name == 'loginView'){
    			vm.topBar = false;
    		}else {
    			vm.topBar = true;
    		}
    		console.log(to.name)
		})
  	},
  	beforeRouteLeave (to, from , next) {
  		$("body").removeClass('noFoot');
	    next()
	}
}
</script>
<style lang="scss">
	.member{
		background:#f5f5f5;
		box-sizing:border-box;
		padding-bottom:.6rem;
		.topBar{
			height:.8rem;
			line-height: .8rem;
			padding:0 .2rem;
			border-bottom:1px solid #ddd;
			background:#fff;
			.iconfont{
				font-size:.5rem;
			}
			.title{
				text-align:center;
				font-size: .36rem;
			}
		}
		.subNav{
			.nav-hd{
				position:relative;
				width: .4rem;
				height: 100%;
				span{
					position:absolute;
					top:50%;
					height: 2px;
					width: .4rem;
					background:#777;
					transition: all .3s linear;
				}
				.line-1{
					margin-top:-6px;
				}
				.line-2{
					width: .28rem;
				}
				.line-3{
					margin-top:6px;
				}
			}
			.nav-bd{
				position: fixed;
				top:0;
				left:0;
				width: 100%;
				height: 100%;
				transform:translateX(-100%);
				z-index:100;
				.mask{
					position: absolute;
					top:0;
					left:0;
					width: 100%;
					height: 100%;
					background:rgba(0,0,0,0);
					transition: all .3s linear;
				}
				.navs-group{
					position:absolute;
					width: 50%;
					left:0;
					top:0;
					height: 100%;
					background:#fff;
					transform:translateX(-100%);
					transition: all .3s linear;
				}
				.nav-list{
					position:absolute;
					top: 50%;
					transform:translateY(-50%);
					width: 100%;
					text-align:center;
					font-size:.3rem;
					li{
						border-bottom:1px solid #f5f5f5;
						&:last-child{
							border-bottom:none;	
						}
					}
					.close-btn{
						margin-top:.5rem;
					}
				}
			}
			&.active{
				.nav-hd{
					.line-1{
						margin:0;
						transform:rotate(45deg);
					}
					.line-2{
						opacity:0;
					}
					.line-3{
						margin:0;
						transform:rotate(-45deg);
					}
				}
				.nav-bd{
					transform:translateX(0);
					.mask{
						background:rgba(0,0,0,.6);
					}
					.navs-group{
						transform:translateX(0);
					}
				}
			}
		}

.line-2{

	}	}
</style>


// WEBPACK FOOTER //
// src/page/memberView.vue